import { getPendoConfig } from "src/repos/pendo";
import { termsAccepted } from "src/utils/session";

function loadPendo(apiKey) {
  (function (p, e, n, d, o) {
    var v, w, x, y, z;
    o = p[d] = p[d] || {};
    o._q = o._q || [];
    v = ["initialize", "identify", "updateOptions", "pageLoad", "track"];
    for (w = 0, x = v.length; w < x; ++w)
      (function (m) {
        o[m] =
          o[m] ||
          function () {
            o._q[m === v[0] ? "unshift" : "push"](
              [m].concat([].slice.call(arguments, 0))
            );
          };
      })(v[w]);
    y = e.createElement(n);
    y.async = !0;
    y.src = "https://cdn.pendo.io/agent/static/" + apiKey + "/pendo.js";
    z = e.getElementsByTagName(n)[0];
    z.parentNode.insertBefore(y, z);
  })(window, document, "script", "pendo");
}

export function initializePendo() {
  if (termsAccepted())
    getPendoConfig()
      .then((r) => r.json())
      .then(({ data: { token, config } }) => {
        // if token is null or empty string, then backend env variable hasn't been set or set with a value
        if (token) {
          loadPendo(token);
          window.pendo.initialize(config);
        }
      });
}
